import React from "react";
import Header from "./compoments/header";
import styles from './index.module.scss'
import Account from "./compoments/account";

const AccountManagement = () => {

    return <div className={styles.warpper}>
        <div>
            <Header />
        </div>

        <div className={styles.line}/>

        <div className={styles.account}>
            <Account />
        </div>
    </div>
}

export default AccountManagement